import { render, staticRenderFns } from "./RefillProductsTable.vue?vue&type=template&id=6e1fd73a&scoped=true"
import script from "./RefillProductsTable.vue?vue&type=script&lang=js"
export * from "./RefillProductsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1fd73a",
  null
  
)

export default component.exports